import { render } from "./contextmenu.vue?vue&type=template&id=c9139626&ts=true"
import script from "./contextmenu.vue?vue&type=script&lang=ts"
export * from "./contextmenu.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\demo\\vue3-tree-org\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__